/** The one HTTP client every module is handed (never a bare `$fetch`). Defined beside `useApi`. */
export type { ApiFetch } from '~/composables/useApi'

/**
 * The documents browser's shared vocabulary — the types and constants more than one of the
 * store's modules needs (MAR-948). Re-exported by `~/stores/documents`, which is where every caller
 * imports them from.
 */

export type SortField = 'name' | 'date' | 'created' | 'type' | 'sort_order'
export type SortOrder = 'asc' | 'desc'
export const SORT_FIELDS: readonly SortField[] = ['name', 'date', 'created', 'type', 'sort_order']

/**
 * Whether a request ANSWERED, and how — never how many rows it returned.
 *
 * Introduced for search by AlexAmin/marcus#440 (borrowed in turn from `DeleteDocumentDialog.vue`)
 * and extended to every listing path by AlexAmin/marcus#469. The feature doc states the rule in its
 * general form: *una búsqueda fallida debe VERSE desconocida, no afirmar una lista vacía.* An
 * unknown must look unknown.
 */
export type LoadState = 'idle' | 'loading' | 'ready' | 'failed'

export interface DeleteItemsResult {
  deletedIds: string[]
  failedIds: string[]
}

/**
 * Page size for both the finder's folder listing and the sidebar's per-case cap (MAR-93).
 *
 * Mirrors `DEFAULT_PAGE_SIZE` in `server/services/items/catalog.ts`. Kept as a plain constant rather
 * than imported from the server: the value is a UI pacing decision, and the server clamps whatever
 * arrives anyway, so the two can never disagree in a way that matters.
 */
export const PAGE_SIZE = 100

/**
 * How many search hits the finder asks for at a time (AlexAmin/marcus#169).
 *
 * Deliberately smaller than `PAGE_SIZE`: the ranked candidate pool the server merges is itself
 * bounded (20 keyword + 50 vector), so a page of 100 would swallow every result in one request and
 * "Cargar más" would never appear even when the ranking had more to give. 25 keeps the control
 * meaningful and keeps the first paint small.
 */
export const SEARCH_PAGE_SIZE = 25

/** The listing params every read carries: the active sort and the finder's type/state lens. */
export interface ListingParams {
  sort: SortField
  order: SortOrder
  types: string | undefined
  statuses: string | undefined
}
